module.exports = __webpack_public_path__ + "img/icon-secure.ff7fcbdd.svg";